import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

export default function ExternalOfferView() {
  const { token } = useParams();
  const [offer, setOffer] = useState(null);
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');
  const [acting, setActing] = useState(false);

  useEffect(() => {
    async function load() {
      setStatus('loading');
      try {
        const res = await fetch(`${API_URL}/api/v1/documents/offers/public/${token}`);
        const data = await res.json();
        if (data.success) {
          setOffer(data.offer);
          setStatus('loaded');
        } else {
          setStatus('error');
          setMessage(data.message || 'Offer not found');
        }
      } catch {
        setStatus('error');
        setMessage('Error loading offer letter');
      }
    }
    if (token) load();
  }, [token]);

  const respond = async (action) => {
    setActing(true);
    setMessage('');
    try {
      const res = await fetch(`${API_URL}/api/v1/documents/offers/public/${token}/${action}`, {
        method: 'POST',
      });
      const data = await res.json();
      if (data.success) {
        setOffer((prev) => ({ ...prev, status: data.status }));
        setMessage(action === 'accept' ? 'Offer accepted.' : 'Offer declined.');
      } else {
        setMessage(data.message || `Failed to ${action}`);
      }
    } catch {
      setMessage(`Error while trying to ${action}`);
    } finally {
      setActing(false);
    }
  };

  if (status === 'loading') {
    return <div style={{ padding: 48, textAlign: 'center' }}>Loading offer…</div>;
  }
  if (status === 'error') {
    return <div style={{ padding: 48, textAlign: 'center', color: '#dc2626' }}>{message}</div>;
  }

  const pending = offer.status === 'pending';

  return (
    <div style={{ maxWidth: 640, margin: '40px auto', background: '#fff', borderRadius: 16, boxShadow: '0 2px 16px #e5e7eb', padding: 32 }}>
      <h2 style={{ textAlign: 'center', marginBottom: 8, color: '#16a34a' }}>Offer Letter</h2>
      <p style={{ textAlign: 'center', color: '#64748b', marginTop: 0 }}>
        {offer.company_name || 'Company'}
      </p>
      <div style={{ marginBottom: 20, lineHeight: 1.7 }}>
        <div><b>Name:</b> {offer.name}</div>
        <div><b>Email:</b> {offer.email}</div>
        <div>
          <b>Status:</b>{' '}
          <span style={{ color: offer.status === 'accepted' ? '#16a34a' : offer.status === 'declined' ? '#dc2626' : '#d97706', fontWeight: 700 }}>
            {offer.status}
          </span>
        </div>
      </div>

      {offer.pdf_url && (
        <a
          href={`${API_URL}/api/v1/documents/offers/public/${token}/download`}
          target="_blank"
          rel="noopener noreferrer"
          style={{ display: 'block', textAlign: 'center', marginBottom: 20, color: '#2563eb', fontWeight: 600 }}
        >
          Download / view PDF
        </a>
      )}

      {message && (
        <div style={{ marginBottom: 16, padding: 12, borderRadius: 8, background: '#f0fdf4', color: '#166534' }}>
          {message}
        </div>
      )}

      {pending ? (
        <div style={{ display: 'flex', gap: 12, justifyContent: 'center' }}>
          <button
            type="button"
            disabled={acting}
            onClick={() => respond('accept')}
            style={{ padding: '12px 24px', borderRadius: 8, border: 'none', background: '#16a34a', color: '#fff', fontWeight: 700, cursor: 'pointer' }}
          >
            Accept
          </button>
          <button
            type="button"
            disabled={acting}
            onClick={() => respond('decline')}
            style={{ padding: '12px 24px', borderRadius: 8, border: '1.5px solid #dc2626', background: '#fff', color: '#dc2626', fontWeight: 700, cursor: 'pointer' }}
          >
            Decline
          </button>
        </div>
      ) : (
        <p style={{ textAlign: 'center', color: '#64748b' }}>This offer has already been responded to.</p>
      )}
    </div>
  );
}
